'use client';

import React, { useState } from 'react';

import { Typography } from 'lighthouse';

import { batteryLandingPriceBasis, priceBasisRules } from '@/constants/batteryLanding';

import { PriceBasisNoteProps } from './models';

import { ArrowDown2, InfoCircle } from 'iconsax-react';

export const PriceBasisNote = ({ className = '', listClassName = 'md:grid-cols-3', isExpandable = true }: PriceBasisNoteProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`flex flex-col gap-2 ${className}`}>
            <div className='flex flex-wrap items-center justify-between gap-x-4 gap-y-1 rounded-xl border border-primary/15 bg-primary/5 px-4 py-2.5'>
                <span className='flex items-center gap-2 text-xs text-blackHighEmphasis md:text-sm'>
                    <InfoCircle size={18} color='currentcolor' className='shrink-0 text-primary' />
                    {batteryLandingPriceBasis.strip}
                </span>
                {isExpandable && (
                    <button
                        type='button'
                        aria-expanded={isOpen}
                        onClick={() => setIsOpen((value) => !value)}
                        className='flex cursor-pointer items-center gap-1 border-none bg-transparent p-0 text-xs font-bold text-primary
                            [font-family:inherit] md:text-sm'>
                        {batteryLandingPriceBasis.title}
                        <ArrowDown2 size={16} color='currentcolor' className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                    </button>
                )}
            </div>

            {isExpandable && isOpen && (
                <ul className={`m-0 grid list-none gap-2 p-0 ${listClassName}`}>
                    {priceBasisRules.map((rule) => (
                        <li key={rule.id} className='flex flex-col gap-1 rounded-xl border border-N200 bg-white p-3'>
                            <Typography variant='subtitle2' component='h3' color='blackHighEmphasis' className='font-bold'>
                                {rule.title}
                            </Typography>
                            <Typography variant='caption' component='p' color='blackMediumEmphasis' className='leading-7'>
                                {rule.description}
                            </Typography>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};
